import React from "react";

function FileTypeUploadProperties({ data, setData }) {
  return <></>;
}

export default FileTypeUploadProperties;
